import { compact } from 'lodash';
import {
  clientNameColumn,
  serviceTypeColumn,
  networkColumn,
} from '../baseColumns';
import {
  actionMenu,
  dateSent,
  lastUpdated,
  organization,
  recipient,
  status,
} from './columns';

export function acceptedClosedConfig(isSuperNetwork) {
  return compact([
    organization(),
    networkColumn(isSuperNetwork),
    clientNameColumn(),
    serviceTypeColumn(),
    lastUpdated(),
  ]);
}

export function acceptedOpenConfig(isSuperNetwork) {
  return compact([
    organization(),
    networkColumn(isSuperNetwork),
    clientNameColumn(),
    serviceTypeColumn(),
    lastUpdated(),
  ]);
}

export function allConfig(statuses = [], isSuperNetwork, currentSort, onSortColumn) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(currentSort, onSortColumn),
    serviceTypeColumn(),
    status(statuses),
    lastUpdated(currentSort, onSortColumn),
  ]);
}

export function inReviewConfig(isSuperNetwork) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(),
    serviceTypeColumn(),
    lastUpdated(),
  ]);
}

export function needsActionConfig(isSuperNetwork) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(),
    serviceTypeColumn(),
    lastUpdated(),
  ]);
}

export function pendingConsentConfig(actions = [], isSuperNetwork) {
  return compact([
    networkColumn(isSuperNetwork),
    recipient(),
    clientNameColumn(),
    serviceTypeColumn(),
    dateSent(),
    actionMenu(actions),
  ]);
}
